<div style="margin: 10px;">

	<assetpanda-export-config [Network]="Network" [AssetPandaExport]="AssetPandaExport" [Agent]="Agent" [ScheduledDiscovery]="Discovery"
						[EnableExportOrigin]="true"></assetpanda-export-config>

</div>
